import { privacyText } from "./privacy.js";

export const siteSettings = {
  brandName: "Oasi Bagni",
  company_name: "Davom S.r.l.",
  phone: "393520518943",
  notification_email: "info@oasibagni.it",
  pec: "davomsrl@pec.it",
  whatsapp_number: "393520518943",
  address: "Milano, Via Rembrandt 69, 20147",
  main_city: "Milano",
  vat_cf: "12938940967",
  business_register: "Iscrizione Registro Imprese di Milano, Monza Brianza, Lodi",
  rea: "MI-2694146",
  share_capital: "€ 10.000,000",
  served_areas: "Milano, provincia di Milano, zona ovest Milano, Corbetta, Magenta, Abbiategrasso, Vittuone, Sedriano, Arluno, Rho, Legnano, Parabiago, Novara e zone limitrofe.",
  guida_pdf_url: "",
  privacy_text: privacyText,
  cookie_text: `Cookie Policy

Questa pagina e un testo base da sostituire con la versione definitiva.

Il sito puo utilizzare cookie tecnici necessari al funzionamento e, se configurati, strumenti di analisi o tracciamento marketing. Prima della pubblicazione e consigliabile configurare una cookie policy completa e un banner cookie conforme.`,
};

export const zapierConfig = {
  guidaWebhook: process.env.REACT_APP_ZAPIER_GUIDA_WEBHOOK || "https://hooks.zapier.com/hooks/catch/24983319/uvwlvjy/",
  sopralluogoWebhook: process.env.REACT_APP_ZAPIER_SOPRALLUOGO_WEBHOOK || "",
};
